<template>
  <div class="div">
    <vs-col
      vs-lg="6"
      vs-md="6"
      vs-sm="12"
      vs-xs="12"
      class="p-0 leeft title-2"
      :style="
        'min-height: 100vh;background: ' +
        (config.color ? config.color : '#f89c31') +
        ' ;'
      "
    >
      <span style="font-size: 50px; color: #333">{{
        config.textNumber && config.textNumber != "" && config.textNumber != " "
          ? config.textNumber
          : "Numéro"
      }}</span>
      <!-- <div v-for="(queue, indexQueue) in queues" :key="'q'+indexQueue"> -->
      <vs-col
        vs-lg="12"
        vs-md="12"
        vs-sm="12"
        vs-xs="12"
        class="mt-2 pt-2"
        v-for="(ticket, index) in tickets"
        :key="'p' + index"
      >
        <span
          v-if="ticket && ticket.public_identifier"
          :class="
            'size-length-' +
            (ticket.sizeLength >= 10 ? 10 : ticket.sizeLength + 2)
          "
        >
          {{ ticket.public_identifier }}
        </span>
        <span
          :class="
            'size-length-' +
            (ticket.sizeLength >= 10 ? 10 : ticket.sizeLength + 2)
          "
          v-else
          >--</span
        >
      </vs-col>
      <!-- </div> -->
    </vs-col>
    <vs-col
      vs-lg="6"
      vs-md="6"
      vs-sm="12"
      vs-xs="12"
      class="p-0 riight title-2"
      style="min-height: 100vh"
    >
      <span
        :style="
          'font-size: 50px;color: ' +
          (config.color ? config.color : '#f89c31') +
          ';'
        "
        >{{
          config.textCounter &&
          config.textCounter != "" &&
          config.textCounter != " "
            ? config.textCounter
            : "Guichet"
        }}</span
      >
      <!-- <div v-for="(queue, indexQueue) in queues" :key="'q2'+indexQueue"> -->
      <vs-col
        vs-lg="12"
        vs-md="12"
        vs-sm="12"
        vs-xs="12"
        class="mt-2 pt-2"
        v-for="(ticket, index) in tickets"
        :key="'p2' + index"
      >
        <span
          v-if="ticket && ticket.counter_id && ticket.counter_id != -1"
          :class="'size-length-' + (ticket.sizeLength + 2)"
        >
          {{ ticket.counter_name ? ticket.counter_name : "--" }}
        </span>
        <span :class="'size-length-' + (ticket.sizeLength + 2)" v-else>
          --
        </span>
      </vs-col>
      <!-- </div> -->
    </vs-col>
  </div>
</template>
<script>
import { displayService } from "../../_services";
import { mapState } from "vuex";

export default {
  name: "WaitingList",
  data: () => ({
    title: "Waiting List",
    targetCounter: null,
    timeLeft: 0,
    waitingLists: [],
    ticketNumber: null,
    counter: null,
    statusUpdateTimestamp: "",
    estimatedTimeToSpend: 0,
    old_waitingList: [],
    activeList: [],
    i: 0,
    show_approx_time: true,
    config: {
      voiceNumber: "",
      voiceCounter: "",
    },
  }),
  props: {
    queues: Array,
    tickets: Array,
  },
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#queue-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#queue-box > .con-vs-loading");
    },
    getDisplayWaitingList() {
      this.queues.map((queue) => {
        displayService.getWaitingList(queue.queue.id).then(
          function (data) {
            if (data.totalWaiting > 0) {
              let aze = data.waiting_list.filter((obj) => {
                // if(obj.status === 'inservice')
                //     return obj;
                return obj.status === "inservice";
              });

              this.activeList.push(aze);
              console.log("activeList_______________");
              console.log(this.activeList);
              // if(this.activeList){
              //     this.ticketNumber = this.activeList.public_identifier;
              //     this.statusUpdateTimestamp = this.activeList.statusUpdateTimestamp;
              //     this.estimatedTimeToSpend = this.activeList.estimatedTimeToSpend;
              //     this.counter = this.activeList.counter_id;

              //     setInterval(function () {
              //         this.calculateTimeLeft()
              //     }.bind(this), 1000);
              //     this.calculateTimeLeft();
              // }
            }
          }.bind(this)
        );
      });
    },
    calculateTimeLeft() {
      let minutesDiff = Math.round(
        this.$moment
          .duration(
            this.$moment(this.statusUpdateTimestamp)
              .add(this.estimatedTimeToSpend, "minutes")
              .diff(this.$moment())
          )
          .asMinutes()
      );
      this.timeLeft = minutesDiff >= 1 ? minutesDiff : 1;
    },
  },

  computed: {},
  mounted() {
    this.config = JSON.parse(
      JSON.parse(localStorage.getItem("display")).display.config
    );

    if (JSON.parse(localStorage.getItem("display")).display.show_approx_time) {
      this.show_approx_time = JSON.parse(
        localStorage.getItem("display")
      ).display.show_approx_time;
    }
    // this.getDisplayWaitingList();
  },
};
</script>
<style scoped>
.title-2 {
  text-align: center;
  font-weight: bold;
  color: #fff;
  padding-top: 20px;
}
.title-2 span {
  text-transform: uppercase !important;
}
.info-2 {
  font-size: 6em;
  font-weight: bold;
}
.leeft {
  color: #333;
  color: #fff;
  font-weight: bold;
}
.riight {
  background: #333;
  color: #fff;
  font-weight: bold;
}
.size-length-1 {
  font-size: 7em !important;
}
.size-length-2 {
  font-size: 7em !important;
}
.size-length-3 {
  font-size: 4em !important;
}
.size-length-4 {
  font-size: 4em !important;
}
.size-length-5 {
  font-size: 5em !important;
}
.size-length-6 {
  font-size: 5em !important;
}
.size-length-7 {
  font-size: 5em !important;
}
.size-length-8 {
  font-size: 4em !important;
}
.size-length-9 {
  font-size: 4em !important;
}
.size-length-10 {
  font-size: 3em !important;
}
.size-length-11 {
  font-size: 3em !important;
}
.size-length-12 {
  font-size: 2.1em !important;
}
/*008fc9*/
</style>